import { render, staticRenderFns } from "./PresentationDetailCard.vue?vue&type=template&id=f7106916"
import script from "./PresentationDetailCard.vue?vue&type=script&lang=js"
export * from "./PresentationDetailCard.vue?vue&type=script&lang=js"
import style0 from "./PresentationDetailCard.vue?vue&type=style&index=0&id=f7106916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports